import React from 'react'
// ##
import SubTypesTable from '../../modules/SubType/components/SubTypesTable'

export default function SubTypePage() {
  return <SubTypesTable />
}
